import React, { useEffect } from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { ItemOpenedTracker_item$key } from './__generated__/ItemOpenedTracker_item.graphql';
import { useRegisterView } from 'utils/tracking/registerView';

const fragment = graphql`
  fragment ItemOpenedTracker_item on Node {
    __typename
    id
    ... on FolderItem {
      publishState
    }
    ... on Event {
      publishState
    }
  }
`;

type ItemOpenedTrackerProps = {
  item: ItemOpenedTracker_item$key;
};

export const ItemOpenedTracker: React.FC<ItemOpenedTrackerProps> = ({
  item,
}) => {
  const node = useFragment(fragment, item);
  const registerView = useRegisterView();

  useEffect(() => {
    if (node) {
      if (['VaultItem', 'Member'].includes(node.__typename)) {
        registerView(node.id);
      } else {
        if (node.publishState === 'PUBLISHED') {
          registerView(node.id);
        }
      }
    }
  }, []);

  return null;
};
